import { atom } from 'recoil';

export const setMedicineData = atom({
    key: 'setMedicineData', // unique ID (with respect to other atoms/selectors)
    default: [] // default value (aka initial value)
});  